<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-18 19:34:51
-->
<template>
  <veStuLiteraryActive viewType="my" slot="table"></veStuLiteraryActive>
</template>

<script>
import veStuLiteraryActive from './base/veStuLiteraryActive';
export default {
  components: {
    veStuLiteraryActive
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
